import React, {useState, useMemo, FunctionComponent, useEffect} from 'react';
import {connect} from 'react-redux';
import './OrderPage.less';
import {useHistory, useParams} from 'react-router-dom';
import {Layout} from 'new-components/layout/Layout';
import {BackButton} from "elements/back-button/BackButton";
import {PageHeader} from "compositions/page-header/PageHeader";
import {OrderInfo} from "compositions/order-info/OrderInfo";
import {largeScreenMediaQuery, PhoneCodes} from "new-constants/common.constants";
import {Comment} from "elements/comment/Comment";
import {Rate} from "compositions/rate/Rate";
import {CartDisplay} from "compositions/cart-display/CartDisplay";
import {Button} from "elements/button/Button";
import {useMediaQuery} from "react-responsive";
import {ContactInfo} from "compositions/contact-info/ContactInfo";
import {getOrderFromCache} from "helpers/order.helper";
import {CashPointsDefaultName} from "new-constants/common.constants";
import {getPaymentTypeName} from "helpers/purchase.helper.ts";
import {Block} from "compositions/block/Block.tsx";
import {Card} from "elements/card/Card.tsx";
import {Offline} from "new-components/popups/offline/Offline";
import {DialogStack} from "dialog-layout/dialog-stack/DialogStack";
import {DialogManager} from "dialog-layout/dialog-manager/DialogManager";
import {
	getCurrentCustomerSelector, getCurrentRestaurantIdSelector, getCurrentRestaurantListSelector,
	getCurrentRestaurantSelector, getCurrentServerPopupsSelector, getRestaurantCacheSelector,
	getTranslationsSelector, getCurrentServerConfig
} from "../../../selectors";
import {EMAIL_RECEIPT_POPUP, EmailReceipt} from "new-components/popups/email-receipt/EmailReceipt";
import {CHECK_PHONE_CODE, SEND_RECEIPT, SET_PHONE} from "new-constants/api.constants";
import {
	cancelEmailReceipt,
	cancelPhone,
	doneEmailReceipt,
	openEmailReceipt,
	openPhone, openProfile,
} from "new-actions/popup.actions";
import {getSafeTranslation} from "helpers/localization.helper.ts";
import {TranslationsContext} from "contexts/translations-context";
import {ADD_TO_HOME_SCREEN_POPUP, AddToHomeScreen} from "../../popups/add-to-home-screen/AddToHomeScreen";
import {isPWAInstallAvailable} from "../../../helpers/pwa-helper";
import {
	cancelAddToHomeScreen, cancelRepeatOrderConfirmation, cancelRepeatOrderErrorMessage,
	doneAddToHomeScreen, doneRepeatOrderConfirmation,
	doneServerPopup,
	openRepeatOrderConfirmation
} from "../../../actions/popup.actions";
import {openExternalLink, openMenuEntryLink, openRestaurantLink} from "../../../actions/link.actions";
import {ServerPopupContainer} from "../../popups/server-popup/ServerPopup.container";
import {Confirmation, REPEAT_ORDER_CONFIRMATION_POPUP} from "../../popups/confirmation/Confirmation";
import {getOrderingTypeFromOrder} from "../../../helpers/order.helper";
import {OrderingTypes} from "../../../constants/common.constants";
import {REPEAT_ORDER} from "../../../constants/api.constants";
import {ErrorMessage, REPEAT_ORDER_ERROR_MESSAGE_POPUP} from "../../popups/error-message/ErrorMessage";
import {isRestaurantDineIn} from "helpers/restaurant.helper";
import { setInfoMessage } from "../../../managers/client-log.manager";
import ReactPixel from "react-facebook-pixel";
import {RegularCustomer} from "compositions/regular-customer/RegularCustomer";
import {Phone, PHONE_POPUP} from "new-components/popups/phone/Phone";
import {confirmPhone, guestOrderLoginAnonymously} from "new-actions/customer.actions";
import {CustomerType} from "reducers/customer.reducer.types";
function parsePrice(stringPrice) {
	return Number(stringPrice.replace(',-', '').replace(',', '.'));
}

function getCartItemsFromOrder(order) {
	return order.orderItems.map(orderItem => {
		
		const modifiersPrice =
			orderItem.modsArray.reduce((totalPrice, modifier) => {
				return totalPrice + parsePrice(modifier.price);
			}, 0) * orderItem.quantity;
		
		return {
			id: orderItem.id,
			name: orderItem.menuEntry,
			quantity: orderItem.quantity,
			price: (orderItem.sum + (orderItem.discountSum || 0) - modifiersPrice) / orderItem.quantity,
			modifierSelections: !!orderItem.modifierSelections && {
				1: [
					...Object.keys(orderItem.modifierSelections)
					.map(modifierGroupId => orderItem.modifierSelections[modifierGroupId]).flat()
				]
			},
			selectedModifierIds: {
				1: orderItem.modsArray.map(modifier => modifier.id)
			},
			modifierGroups: [{
				modifierGroupId: 1,
				modifiers: orderItem.modsArray.map(modifier => ({
					modifierId: modifier.id,
					name: modifier.name,
					price: parsePrice(modifier.price) //TODO fetch numeric price from backend
				}))
			}],
			vatPercent: orderItem.vatPercent + '%',
			vatSum: orderItem.vatSum
		}
	})
}

const RepeatOrderingTypeTranslations = {
	[OrderingTypes.pickup]: 'RepeatOrderConfirmation.pickupTypeName',
	[OrderingTypes.delivery]: 'RepeatOrderConfirmation.deliveryTypeName',
	[OrderingTypes.dineIn]: 'RepeatOrderConfirmation.dineInTypeName'
};

const OrderPage = ({
	order,
	currentRestaurantId,
	currentCustomer,
	translations,
	connectivity,
	popup,
	currentServerPopups,
	fetchError,
	restaurantCache,
	currentRestaurantList,
	fetchProgress,
	currentServerConfig,
	
	openEmailReceipt,
	cancelEmailReceipt,
	doneEmailReceipt,
	cancelAddToHomeScreen,
	doneAddToHomeScreen,
	doneServer,
	openExternalLink,
	openRestaurantLink,
	openMenuEntryLink,
	openRepeatOrderConfirmation,
	cancelRepeatOrderConfirmation,
	doneRepeatOrderConfirmation,
	cancelRepeatOrderErrorMessage,
	cancelPhone,
	confirmPhone,
	openPhone,
	openProfile,
	guestOrderLoginAnonymously
}) => {
	const history = useHistory();
	const {orderId, isReview} = useParams();
	
	//DEBUG
	const [__rate, __setRate] = useState(0);
	
	const [showServerPopup, setShowServerPopup] = useState(true);
	
	useEffect(() => {
		setShowServerPopup(true);
	}, [currentRestaurantId]);
	
	const isLargeScreen = useMediaQuery({query: largeScreenMediaQuery});
	
	const currentOrder = useMemo(() => getOrderFromCache(orderId, order.cache), [orderId, order.cache]);
	const cartItems = useMemo(() => getCartItemsFromOrder(currentOrder), [currentOrder]);
	const orderRestaurant = useMemo(
		() => restaurantCache.find(restaurant => restaurant.restaurantId === currentOrder?.restaurantId),
		[restaurantCache, currentOrder]
	);

	useEffect(() => {
		if(!currentServerConfig?.googleTagManagerId || !currentOrder) {
			return;
		}

		window.dataLayer = window.dataLayer || [];
		function gtag() {
			dataLayer.push(arguments);
		}
		gtag('event', 'purchase', {
			transaction_id: currentOrder.orderId,
			value: currentOrder.amount
		});
	}, [currentOrder, currentServerConfig]);

	useEffect(() => {
		if(!currentServerConfig?.facebookPixelId || !currentOrder) {
			return;
		}
		ReactPixel.trackCustom('purchase', {
			transaction_id: currentOrder.orderId,
			value: currentOrder.amount,
		});
	}, [currentOrder, currentServerConfig]);
	
	if (!currentOrder) {
		return <Layout>Order not found</Layout>
	}
	
	const orderShortRestaurant = currentRestaurantList.find(restaurant => restaurant.restaurantId === currentOrder.restaurantId);

	if (!orderShortRestaurant?.restaurantType) {
		setInfoMessage(`Order Page for qtf-2216:
			orderShortRestaurant: ${JSON.stringify(orderShortRestaurant)}
			currentRestaurantList: ${JSON.stringify(currentRestaurantList)}
		`);
	}



	const orderingType = getOrderingTypeFromOrder(currentOrder, orderShortRestaurant);
	
	//TODO fix custom payment name display
	
	return (
		<TranslationsContext.Provider value={translations}>
			<Layout>
				<div className={"order-page" + ((!(currentCustomer?.nickname && currentCustomer?.phone) || currentCustomer.type === CustomerType.GUEST) ? ' show-regular-customer' : '')}>
					<div className="order-page__back">
						<BackButton onClick={() => {
							if (!currentCustomer.nickname || !currentCustomer.phone || currentCustomer.type === CustomerType.GUEST) {
								guestOrderLoginAnonymously();
							}
							history.goBack();
						}}/>
					</div>
					<div className="order-page__header">
						<PageHeader
							title={getSafeTranslation('OrderPage.headerTitle', translations)}
							description={getSafeTranslation('OrderPage.headerDescription', translations)}
						/>
					</div>
					<div className="order-page__general-info">
						<OrderInfo
							status={currentOrder.statusString}
							readyTime={currentOrder.pickupTime}
							isPaid={currentOrder.isPaid}
							paymentType={getPaymentTypeName(currentOrder.paymentType,
								currentOrder.subPaymentTypeName,
								(orderRestaurant?.cashPointsName) || CashPointsDefaultName,
								translations)}
							address={currentOrder.pickupAt || currentOrder.deliveryTo}
							orderId={currentOrder.orderId}
							placedAt={isRestaurantDineIn(orderShortRestaurant) ? currentOrder.placedAt : null}
						/>
					</div>
					{
						currentOrder.comment && (
							<div className="order-page__comment">
								<Block title={getSafeTranslation('OrderPage.commentBlockTitle', translations)}>
									<Card>
										<Comment text={currentOrder.comment}/>
									</Card>
								</Block>
							</div>
						)
					}
					{
						false && (<div className="order-page__rate">
							<Block title={getSafeTranslation('OrderPage.rateBlockTitle', translations)}>
								<Card>
									<Rate
										currentValue={__rate}
										maxValue={5}
										onChange={__setRate}
									/>
								</Card>
							</Block>
						</div>)
					}
					<div className="order-page__items">
						<Block title={getSafeTranslation('OrderPage.itemsBlockTitle', translations)}>
							<Card isNoPaddings>
								<CartDisplay
									cartItems={cartItems}
									discount={-currentOrder.orderItems.reduce((accum, orderItem) => {
										return accum + (orderItem.discountSum || 0);
									}, 0)}
									delivery={currentOrder.deliveryPrice}
									deliveryVat={currentOrder.deliveryVat}
									deliveryVatPercent={currentOrder.deliveryVatPercent}
									cashpointsName={(orderRestaurant?.cashPointsName) || CashPointsDefaultName}
									cashpoints={currentOrder.usedCashPoints}
									tip={currentOrder.tip}
									vat={currentOrder.vat}
									total={currentOrder.amount}
									isReadOnly
									isHighlightTotal
								/>
							</Card>
						</Block>
					</div>

					<div className="order-page__email">
						<Button
							onClick={() => openEmailReceipt()}
							isOutlined
						>
							{getSafeTranslation('OrderPage.emailButtonCaption', translations)}
						</Button>
					</div>

					{
						!isReview && (<div className="order-page__repeat">
							<Button
								onClick={openRepeatOrderConfirmation}
								isLoading={fetchProgress[REPEAT_ORDER]}
								isAutoWidth
							>
								{getSafeTranslation('OrderPage.repeatOrderButtonCaption', translations)}
							</Button>
						</div>)
					}
					{
						(orderRestaurant?.phone || orderRestaurant?.address) && (
							<div className="order-page__contact-info">
								<Block title={getSafeTranslation('OrderPage.contactInfoBlockTitle', translations)}>
									<ContactInfo
										phone={orderRestaurant.phone}
										latitude={orderRestaurant.latitude}
										longitude={orderRestaurant.longitude}
										address={orderRestaurant.address}
										zip={orderRestaurant.zipCode}
										contactUsText={orderRestaurant.contactUsText}
									/>
								</Block>
							</div>
						)
					}
					{
						(!(currentCustomer?.nickname && currentCustomer?.phone) || currentCustomer.type === CustomerType.GUEST) && <RegularCustomer
							onLogin={() => {
								if (!currentCustomer.nickname || !currentCustomer.phone) {
									guestOrderLoginAnonymously();
								}
								history.goBack();
								openPhone();
							}}
							onRegister={() => {
								if (!currentCustomer.nickname || !currentCustomer.phone) {
									guestOrderLoginAnonymously();
								}
								history.goBack();
								openProfile();
							}}
							translations={translations}
						/>
					}
					<DialogManager>
						<DialogStack>
							{
								showServerPopup && currentServerPopups?.length > 0 && <ServerPopupContainer
									popups={currentServerPopups}
									onDoneClick={doneServer}
									onExternalLinkClick={openExternalLink}
									onMenuEntryLinkClick={(mainCategoryId, categoryId, menuEntryId) => {
										setShowServerPopup(false);
										openMenuEntryLink(mainCategoryId, categoryId, menuEntryId);
									}}
									onRestaurantLinkClick={openRestaurantLink}
									onOverlayClick={() => setShowServerPopup(false)}
								/>
							}
							{
								popup.includes(EMAIL_RECEIPT_POPUP) && (
									<EmailReceipt
										currentCustomer={currentCustomer}
										title={getSafeTranslation('EmailReceiptPopup.title', translations)}
										defaultEmail={currentCustomer.email}
										defaultSubscribe={currentCustomer.emailWhenOrdering}
										error={fetchError[SEND_RECEIPT]}
										onOverlayClick={() => cancelEmailReceipt()}
										onCancelClick={() => cancelEmailReceipt()}
										onDoneClick={(email, isSubscribe) => doneEmailReceipt(currentOrder.orderId, email, isSubscribe)}
									/>
								)
							}
							{
								popup.includes(PHONE_POPUP) && (<Phone
									phoneCodes={PhoneCodes}
									error={fetchError[SET_PHONE] || fetchError[CHECK_PHONE_CODE]}
									isRequestInProgress={fetchProgress[SET_PHONE]}
									onCancelClick={() => cancelPhone()}
									onDoneClick={phone => {
										confirmPhone(phone);
									}}
									onOverlayClick={() => cancelPhone()}
								/>)
							}
							{
								popup.includes(ADD_TO_HOME_SCREEN_POPUP) && isPWAInstallAvailable() &&
								(<AddToHomeScreen
									onOverlayClick={cancelAddToHomeScreen}
									onDoneClick={doneAddToHomeScreen}
								/>)
							}
							{
								popup.includes(REPEAT_ORDER_ERROR_MESSAGE_POPUP) && <ErrorMessage
									title={getSafeTranslation('RepeatOrderErrorMessagePopup.title', translations)}
									description={fetchError[REPEAT_ORDER]}
									onOverlayClick={cancelRepeatOrderErrorMessage}
									control={<Button
										isAutoWidth
										onClick={cancelRepeatOrderErrorMessage}
									>
										{getSafeTranslation('RepeatOrderErrorMessagePopup.buttonCaption', translations)}
									</Button>}
								/>
							}
							{
								popup.includes(REPEAT_ORDER_CONFIRMATION_POPUP) &&
								<Confirmation
									title={getSafeTranslation('RepeatOrderConfirmation.title', translations)}
									description={
										getSafeTranslation('RepeatOrderConfirmation.description', translations)
										.replace(/(\{.+?\})/gi, '{b}$1{/b}')
										.replace('{restaurantName}', currentOrder.restaurantName)
										.replace('{orderingType}', getSafeTranslation(RepeatOrderingTypeTranslations[orderingType], translations))
									}
									onOverlayClick={cancelRepeatOrderConfirmation}
									onNoClick={cancelRepeatOrderConfirmation}
									onYesClick={() => doneRepeatOrderConfirmation(currentOrder.orderId)}
								/>
							}
						</DialogStack>
						<DialogStack>
							{
								connectivity.isOnline === false && <Offline
								/>
							}
						</DialogStack>
					</DialogManager>
				</div>
			</Layout>
		</TranslationsContext.Provider>
	);
};

const mapStateToProps = state => {
	return {
		order: state.order,
		currentRestaurantId: getCurrentRestaurantIdSelector(state),
		currentCustomer: getCurrentCustomerSelector(state),
		translations: getTranslationsSelector(state),
		connectivity: state.connectivity,
		popup: state.popup,
		fetchError: state.fetchError,
		currentServerPopups: getCurrentServerPopupsSelector(state),
		restaurantCache: getRestaurantCacheSelector(state),
		currentRestaurantList: getCurrentRestaurantListSelector(state),
		fetchProgress: state.fetchProgress,
		currentServerConfig: getCurrentServerConfig(state),
	};
}

const mapDispatchToProps = dispatch => {
	return {
		openEmailReceipt: () => dispatch(openEmailReceipt()),
		cancelEmailReceipt: () => dispatch(cancelEmailReceipt()),
		doneEmailReceipt: (orderId, email, isSubscribe) => dispatch(doneEmailReceipt(orderId, email, isSubscribe)),
		cancelAddToHomeScreen: () => dispatch(cancelAddToHomeScreen()),
		doneAddToHomeScreen: () => dispatch(doneAddToHomeScreen()),
		openExternalLink: (url) => dispatch(openExternalLink(url)),
		openRestaurantLink: (restaurantId) => dispatch(openRestaurantLink(restaurantId)),
		openMenuEntryLink: (mainCategoryId, categoryId, menuEntryId) => dispatch(openMenuEntryLink(mainCategoryId, categoryId, menuEntryId)),
		doneServer: (popupId) => dispatch(doneServerPopup(popupId)),
		openRepeatOrderConfirmation: () => dispatch(openRepeatOrderConfirmation()),
		cancelRepeatOrderConfirmation: () => dispatch(cancelRepeatOrderConfirmation()),
		doneRepeatOrderConfirmation: (orderId) => dispatch(doneRepeatOrderConfirmation(orderId)),
		cancelRepeatOrderErrorMessage: () => dispatch(cancelRepeatOrderErrorMessage()),
		cancelPhone: () => dispatch(cancelPhone()),
		confirmPhone: phone => dispatch(confirmPhone(phone)),
		openPhone: () => dispatch(openPhone()),
		openProfile: () => dispatch(openProfile()),
		guestOrderLoginAnonymously: () => dispatch(guestOrderLoginAnonymously()),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderPage);
